import { render, staticRenderFns } from "./RecordEdit.vue?vue&type=template&id=5fa4a13a&"
import script from "./RecordEdit.vue?vue&type=script&lang=ts&"
export * from "./RecordEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports